import { StatusBar } from 'react-native';
import { NavigationContainer } from './NavigationContainer';
import EpaAuthProvider from '@/contexts/EpaAuthContext';

import { isPatientApp } from '@/config/constants';
import { usePrivacy } from '@/hooks/usePrivacy';

import { DialogProvider } from '@/components/ui/shared/Dialog';

import { AnonymousStack } from './AnonymousStack';
import { PatientStack } from './PatientStack';
import { TherapistStack } from './TherapistStack';
import { useStoreState } from '@/stores/store';
import { PrivacyGuardProvider } from '@/contexts/PrivacyGuardContext';
import { PostHogEventsProvider } from '@/contexts/EventsProvider/PostHogProvider';
import { logError } from '@/utils/logHandling';

function ActiveStack({ isAuthenticated }: { isAuthenticated: boolean }) {
  usePrivacy(isAuthenticated);

  return (
    <>
      {isAuthenticated && isPatientApp ? <PatientStack /> : null}
      {isAuthenticated && !isPatientApp ? <TherapistStack /> : null}
      {!isAuthenticated && <AnonymousStack />}
    </>
  );
}

export function AppNavigation() {
  const { isAuthenticated } = useStoreState((store) => ({
    isAuthenticated: store.isAuthenticated,
  }));

  return (
    <NavigationContainer>
      {/* <PostHogEventsProvider
        onError={(error) => logError('PostHog initialization error:', error)}
      > */}
      <PrivacyGuardProvider isAuthenticated={isAuthenticated}>
        <StatusBar hidden={true} translucent={true} />
        <DialogProvider>
          <EpaAuthProvider>
            <ActiveStack isAuthenticated={isAuthenticated} />
          </EpaAuthProvider>
        </DialogProvider>
      </PrivacyGuardProvider>
      {/* </PostHogEventsProvider> */}
    </NavigationContainer>
  );
}
